import { useState, useEffect } from "react";
import axios from "axios";

const coverageApi = axios.create({
    withCredentials: true,
    baseURL: window.i3.coverageApiURL, //'https://staging-api.i3broadband.com/coverage-api/',//window.i3.coverageApiURL,    
    headers: {
        'Content-Type': 'application/json',        
    }
});
    
const AddressSearch = (props) => {    

    const [searchOptions, setSearchOptions] = useState([]);
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        if (searchValue.length > 5) {
            const getData = setTimeout(() => {
                coverageApi.get(`address/${searchValue}`)            
                .then(response => {
                    setSearchOptions(response.data.Response.results.slice(0, 10));
                });            
            }, 500);

            return () => clearTimeout(getData);
        }
    }, [searchValue]);

    const chooseAddress = (address) => {
        if(!address) {
            return;
        }
        const fromSearchComponent = 1;

        const obj = {
            address,
            fromSearchComponent,
        };
        console.log(address);
        const jsonAddress = JSON.stringify(obj);

        sessionStorage.setItem('bfAdd', jsonAddress);
 
        if(address.redirect_signup !== false) {
            window.location.assign(address.redirect_signup);
            return;
        }        
    }

    return (
        <div className="w-full max-w-xl mx-auto mt-2">
            <div className="address-search-container">
                <input
                    id='searchbox'
                    type="text"
                    placeholder="Street address, City, State, Zipcode"
                    onChange={(e) => setSearchValue(e.target.value)}
                    value={searchValue}
                    className="w-full"
                />
            </div>
            {searchOptions.length > 0 && (
            <div className="text-left mt-2">
                <ul className="address-results">
                {searchOptions.map(option => (
                    <li key={option.id} className="rounded-lg shadow p-4 mb-1 hover:bg-purple hover:text-white cursor-pointer transition flex justify-between" onClick={() => chooseAddress(option)}>
                    {/*  even:bg-zinc-100 */}
                    {option.full_address}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                    </li>
                ))}
                </ul>
            </div>
            )}
            {(searchOptions.length < 1) && (searchValue.length > 5) && (
                <div className="text-left mt-2">
                    <ul className="address-results">
                        <li className="rounded-lg shadow p-4 mb-1 hover:bg-purple hover:text-white cursor-pointer transition flex justify-between">Currently service unavailable at this address</li>
                    </ul>
                </div>
            )}

        </div>
    )
};

export default AddressSearch;